import { Button, Card, CardContent, CardHeader, Divider, FormControl, FormControlLabel, FormHelperText, Grid2, IconButton, Stack, Switch } from "@mui/material"
import DashboardLayout from "../../../layoutcontainers/DashboardLayout"
import { ArrowBack } from "@mui/icons-material"
import MaterialTypography from "../../../components/MaterialTypography"
import { useNavigate, useSearchParams } from "react-router-dom"
import MaterialButton from "../../../components/MaterialButton"
import MaterialBox from "../../../components/MaterialBox"
import MaterialInput from "../../../components/MaterialInput"
import { useBranchFormHandling } from "./components/BranchStateHandle"
import MaterialSelect from "../../../components/MasterSelect"
import { BsFillPersonVcardFill } from "react-icons/bs"
import { useEffect, useState } from "react"
import { fetchData, postData, putData } from "../../../services"
import { contactTypeOptions } from "./components/BranchData"
import { useLoading } from "../../../components/Loading"
import { useSnackbar } from "../../../context/popup"

const BankBranchForm = () => {

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { showSnackbar } = useSnackbar();
    const { setCircleLoading } = useLoading();

    const bankBranchId = searchParams.get("id");
    const pageType = searchParams.get("pageType");
    const pageMode = pageType === "view"
        ? "view"
        : pageType === "edit"
        ? "edit"
        : pageType === "add"
            ? "add"
            : "add";
    const { formData, setFormData, contacts, setContacts, handleChange, checkAllFields } = useBranchFormHandling();
    
    const [bankOptions, setBankOptions] = useState([]);
    const [countryOptions, setCountryOptions] = useState([]);
    const [stateOptions, setStateOptions] = useState([]);
    const [districtOptions, setDistrictOptions] = useState([]);
    const [cityOptions, setCityOptions] = useState([]);
    const [pincodeOptions, setPincodeOptions] = useState([]);

    //Bank and Country Dropdown API
    useEffect(() => {
    if (pageMode !== "view") {

        const fetchAllDropdowns = async () => {
            setCircleLoading(true);
            try {
                const [countryRes, bankRes] = await Promise.all([
                    fetchData(`/reference/general/country?dropdown=true&isActive=true`),
                    fetchData(`/reference/general/bank?dropdown=true&isActive=true`)
                ]);

                // Country Dropdown
                if(countryRes?.success){
                    const formattedCountries = countryRes.data.items.map((item) => ({
                        value: item.id,
                        label: item.displayName,
                    }));
                    setCountryOptions(formattedCountries);
                } 
                else{
                    showSnackbar("Error fetching country data", "error");
                }

                // Bank Dropdown
                if (bankRes?.success) {
                    const formattedBanks = bankRes.data.items.map((item) => ({
                        value: item.id,
                        label: item.name,
                    }));
                    setBankOptions(formattedBanks);
                } 
                else{
                    showSnackbar("Error fetching bank data", "error");
                }

            } 
            catch(error){
                console.error("Error fetching dropdowns:", error);
                showSnackbar("Fetching failed", "error");

            }
            finally{
                setCircleLoading(false);
            }
        };
        fetchAllDropdowns();
    }
    }, [pageMode]);


    //State Dropdown API
    useEffect(() => {
        if (!formData.countryId?.value) return;
        const fetchStateDropdown = async (countryId) => {
            try {
            const response = await fetchData(`/reference/general/state?dropdown=true&isActive=true&countryId=${countryId}`)
            
            if(response?.success){
                const formattedStates = response?.data?.items.map((item) => ({
                value: item.id,
                label: item?.name
                }))
                setStateOptions(formattedStates);
            }
            else{
                //throw error
            }
            }       
            catch (error) {
            console.error('Error Fetching States:', error);
            }
        };
        fetchStateDropdown(formData.countryId.value);
    }, [formData.countryId?.value]);

    //District Dropdown API
    useEffect(() => {
        if (!formData.stateId?.value) return;

        const fetchDistrictDropdown = async () => {

            try {
            const response = await fetchData(`/reference/general/district?dropdown=true&isActive=true&stateId=${formData.stateId?.value}`)
            
            if(response?.success){
                const formattedDistricts = response?.data?.items.map((item) => ({
                    value: item.id,
                    label: item?.name
                }))
                setDistrictOptions(formattedDistricts);
            }
            else{
                //throw error
            }
            } catch (error) {
            console.error('Error Fetching Districts:', error);
            }
        }
        fetchDistrictDropdown();
    }, [formData.stateId?.value]);

    //City Dropdown API
    useEffect(() => {
        if (!formData.districtId?.value) return;

        const fetchCityDropdown = async () => {

            try {
            const response = await fetchData(`/reference/general/city?dropdown=true&isActive=true&districtId=${formData.districtId?.value}`)
            
            if(response?.success){
                const formattedCities = response?.data?.items.map((item) => ({
                    value: item.id,
                    label: item?.name
                }))
                setCityOptions(formattedCities);
            }
            else{
                //throw error
            }
            } catch (error) {
            console.error('Error Fetching Cities:', error);
            }
        }
        fetchCityDropdown();
    }, [formData.districtId?.value]);

    //Pincode Dropdown API
    useEffect(() => {
        if (!formData.cityId?.value) return;

        const fetchPincodeDropdown = async () => {

            try {
            const response = await fetchData(`/reference/general/pincode?dropdown=true&isActive=true&cityId=${formData.cityId?.value}`)
            
            if(response?.success){
                const formattedPincodes = response?.data?.items.map((item) => ({
                    value: item.id,
                    label: item?.pincode
                }))
                setPincodeOptions(formattedPincodes);
            }
            else{
                //throw error
            }
            } catch (error) {
            console.error('Error Fetching Pincodes:', error);
            }
        }
        fetchPincodeDropdown();
    }, [formData.cityId?.value]);

    //post and put api function
    const handleSubmitBankBranch = async () => {
        const payload = {
            branch: {
                bankId: formData?.bankId?.value || "",
                name: formData?.name || "",
                code: formData?.code || "",
                isActive: formData?.active,
            },
            address: {
                addressLine1: formData?.addressLine1 || "",
                addressLine2: formData?.addressLine2 || "",
                landmark: formData?.landmark || "",
                pinCodeId: formData?.pinCodeId?.value || "",
                cityId: formData?.cityId?.value || "",
                latitude: null, 
                longitude: null,
            },
            contacts: contacts.map((c) => ({
                value: c?.value || "",
                contactType: c?.contactType || "",
                primary: true,
                isActive: c?.isActive,
            })),
        };

        //Update
        if(bankBranchId){
            try {
                const response = await putData(`/reference/general/pincode/${bankBranchId}`, payload);
                const responseMessage = response?.message;
                if(response?.success){
                //success message
                    showSnackbar(responseMessage,"success");
                    navigate('/general-master/pincode-list');          
                }
                else{
                    //error message
                    showSnackbar(responseMessage,"error")
                }
            } catch (error) {
                console.error('Error updating data:', error);
                showSnackbar(error?.response?.data?.message || 'Error updating data', "error");
            }
        }
        else{      
        //Submit
            try {
                const response = await postData('/reference/general/pincode', payload);
                const responseMessage = response?.message;
                if(response?.success){
                    //success message
                    showSnackbar(responseMessage,"success");
                    navigate('/general-master/pincode-list');          
                }
                else{
                    //error message
                    showSnackbar(responseMessage,"error")
                }
            } catch (error) {
                console.error('Error posting data:', error);
                showSnackbar(error?.response?.data?.message || 'Error Adding Data', "error");
                //catch error message
            }
        }
    };

    const handleAddContact = () => {
        setContacts([
            ...contacts,
            {
            contactType: "",
            value: "",
            primary: false,
            isActive: true,
            contactTypeStatus: "unchecked",
            valueStatus: "unchecked",
            },
        ]);
    };

    const handleRemoveContact = (index) => {
        const updatedContacts = contacts.filter((_, i) => i !== index);
        setContacts(updatedContacts);
    };

  return (
    <DashboardLayout>
        <Card sx={{minHeight: 650}}>
            <CardHeader
            title={(
                <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
                >
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <IconButton onClick={() => navigate("/general-master/bank-branch-list")}>
                        <ArrowBack />
                        </IconButton>
                        <Stack direction="column" spacing={0}>
                        <MaterialTypography variant="h5" fontWeight="medium">
                            Bank Branch Details
                        </MaterialTypography>
                        <MaterialTypography variant="caption" color="text">
                            Enter New Bank Branch Details respective to the Bank.
                        </MaterialTypography>
                        </Stack>
                    </Stack>
                </Stack>
            )}
            />
            <CardContent>
                <Stack direction="row" spacing={1} >
                    <BsFillPersonVcardFill style={{ fontSize: 20 }} />
                    <MaterialTypography
                        component="label"
                        variant="body2"
                        fontWeight="bold">
                        Bank Information
                    </MaterialTypography>
                </Stack>
                <Grid2 container spacing={1}>
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                Branch Name*
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        success={formData.nameStatus === "success"}
                        error={formData.nameStatus === "error"}
                        disabled={pageMode === "view"}
                        />
                        {formData.nameStatus === "error" && (
                            <FormControl error>
                                <FormHelperText>
                                Branch Name should be at least 1 character and at most 80 characters long.
                                </FormHelperText>
                            </FormControl>
                        )}
                    </Grid2>
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                Branch Code*
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                        name="code"
                        value={formData.code}
                        onChange={handleChange}
                        success={formData.codeStatus === "success"}
                        error={formData.codeStatus === "error"}
                        disabled={pageMode === "view"}
                        />
                        {formData.codeStatus === "error" && (
                            <FormControl error>
                                <FormHelperText>
                                Branch Code should be at least 1 character and at most 30 characters long.
                                </FormHelperText>
                            </FormControl>
                        )}
                    </Grid2>
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                Bank Name*
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialSelect
                        name="bankId"
                        value={formData.bankId}
                        onChange={handleChange}
                        options={bankOptions}
                        success={formData.bankIdStatus === "success"}
                        error={formData.bankIdStatus === "error"}
                        isDisabled={pageMode === "view"}
                        />
                    </Grid2>
                    {(pageMode === "view" || pageMode === "edit") && (
                        <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                            <MaterialBox>
                                <MaterialTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold">
                                    IPL Bank ID
                                </MaterialTypography>
                            </MaterialBox>
                            <MaterialInput
                            name="iplBankId"
                            value={formData.iplBankId}
                            onChange={handleChange}
                            success={formData.iplBankIdStatus === "success"}
                            error={formData.iplBankIdStatus === "error"}
                            disabled
                            />
                        </Grid2>
                    )}
                    <Grid2 size={{lg:2, md:2, sm: 2, xs: 2 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                Actve
                            </MaterialTypography>
                        </MaterialBox>
                        <FormControlLabel
                        control={
                            <Switch
                                checked={formData.active}
                                disabled={pageMode === "view"}
                                onChange={(e) =>
                                    handleChange({
                                        target: {
                                            name: "active",
                                            value: e.target.checked,
                                        },
                                    })
                                }
                                color="primary"
                            />
                        }
                        label={
                            <MaterialTypography variant="caption" fontWeight="bold">
                                {formData?.active ? "Yes" : "No"}
                            </MaterialTypography>
                        }
                        sx={{ marginLeft: 0 }}
                        />
                    </Grid2>
                </Grid2>
                <Divider/>
                <Stack direction="row" spacing={1} >
                    <BsFillPersonVcardFill style={{ fontSize: 20 }} />
                    <MaterialTypography
                        component="label"
                        variant="body2"
                        fontWeight="bold">
                        Address Information
                    </MaterialTypography>
                </Stack>
                <Grid2 container spacing={1}>
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                Country Name*
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialSelect
                        name="countryId"
                        value={formData.countryId}
                        onChange={handleChange}
                        options={countryOptions}
                        success={formData.countryIdStatus === "success"}
                        error={formData.countryIdStatus === "error"}
                        isDisabled={pageMode === "view"}
                        />
                    </Grid2>
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                State Name*
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialSelect
                        name="stateId"
                        options={stateOptions}
                        value={formData.stateId}
                        onChange={handleChange}
                        success={formData.stateIdStatus === "success"}
                        error={formData.stateIdStatus === "error"}
                        isDisabled={formData.countryId === "" || pageMode === "view"}
                        />
                    </Grid2> 
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                District Name*
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialSelect
                        name="districtId"
                        options={districtOptions}
                        value={formData.districtId}
                        onChange={handleChange}
                        success={formData.districtIdStatus === "success"}
                        error={formData.districtIdStatus === "error"}
                        isDisabled={formData.stateId === "" || pageMode === "view"}
                        menuPlacement="top"
                        />
                    </Grid2> 
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                City Name*
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialSelect
                        name="cityId"
                        options={cityOptions}
                        value={formData.cityId}
                        onChange={handleChange}
                        success={formData.cityIdStatus === "success"}
                        error={formData.cityIdStatus === "error"}
                        isDisabled={formData.districtId === "" || pageMode === "view"}
                        menuPlacement="top"
                        />
                    </Grid2>
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                Pin Code*
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialSelect
                        name="pinCodeId"
                        options={pincodeOptions}
                        value={formData.pinCodeId}
                        onChange={handleChange}
                        success={formData.pinCodeIdStatus === "success"}
                        error={formData.pinCodeIdStatus === "error"}
                        isDisabled={formData.cityId === "" || pageMode === "view"}
                        menuPlacement="top"
                        />
                    </Grid2>                    
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                            Address Line 1*
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                        name="addressLine1"
                        value={formData.addressLine1}
                        onChange={handleChange}
                        success={formData.addressLine1Status === "success"}
                        error={formData.addressLine1Status === "error"}
                        disabled={pageMode === "view"}
                        />
                        {
                          formData.addressLine1Status === "error" && (
                            <FormControl error>
                                <FormHelperText>
                                    Address 1 should be between 5-60 characters
                                </FormHelperText>
                            </FormControl>
                          )  
                        }
                    </Grid2>
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                            Address Line 2
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                        name="addressLine2"
                        value={formData.addressLine2}
                        onChange={handleChange}
                        success={formData.addressLine2Status === "success"}
                        error={formData.addressLine2Status === "error"}
                        disabled={pageMode === "view"}
                        />
                        {
                          formData.addressLine2Status === "error" && (
                            <FormControl error>
                                <FormHelperText>
                                    Address 2 should be between 0-60 characters
                                </FormHelperText>
                            </FormControl>
                          )  
                        }
                    </Grid2>
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                            Landmark
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                        name="landmark"
                        value={formData.landmark}
                        onChange={handleChange}
                        success={formData.landmarkStatus === "success"}
                        error={formData.landmarkStatus === "error"}
                        disabled={pageMode === "view"}
                        />
                        {
                          formData.landmarkStatus === "error" && (
                            <FormControl error>
                                <FormHelperText>
                                    Landmark should be between 0-40 characters
                                </FormHelperText>
                            </FormControl>
                          )  
                        }
                    </Grid2>
                    
                </Grid2>
                <Divider/>
                {/* Under Work */}
                {/* <Stack direction="row" spacing={1} >
                    <BsFillPersonVcardFill style={{ fontSize: 20 }} />
                    <MaterialTypography
                        component="label"
                        variant="body2"
                        fontWeight="bold">
                        Contact Information
                    </MaterialTypography>
                    <Button variant="contained" color="dark" onClick={handleAddContact}>
                        + Contact
                    </Button>
                </Stack>
                {contacts.map((index) => (
                <Grid2 container spacing={1}>
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                Contact Type
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialSelect
                        name="contactType"
                        value={contacts.contactType}
                        onChange={handleChange}
                        options={contactTypeOptions}
                        success={contacts.contactTypeStatus === "success"}
                        error={contacts.contactTypeStatus === "error"}
                        isDisabled={pageMode === "view"}
                        menuPlacement="top"
                        />
                    </Grid2>
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                {contacts?.contactType?.label} Value*
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                        name="value"
                        value={contacts.value}
                        onChange={handleChange}
                        success={contacts.valueStatus === "success"}
                        error={contacts.valueStatus === "error"}
                        disabled={pageMode === "view"}
                        />
                        {contacts.valueStatus === "error" && (
                            <FormControl error>
                                <FormHelperText>
                                {formData?.contactType?.label} Name should be at least 1 character and at most 80 characters long.
                                </FormHelperText>
                            </FormControl>
                        )}
                    </Grid2>
                    <Grid2 size={{lg:6, md:2, sm: 2, xs: 2 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                Actve
                            </MaterialTypography>
                        </MaterialBox>
                        <FormControlLabel
                        control={
                            <Switch
                                checked={contacts.isActive}
                                disabled={pageMode === "view"}
                                onChange={(e) =>
                                    handleChange({
                                        target: {
                                            name: "isActive",
                                            value: e.target.checked,
                                        },
                                    })
                                }
                                color="primary"
                            />
                        }
                        label={
                            <MaterialTypography variant="caption" fontWeight="bold">
                                {contacts?.isActive ? "Yes" : "No"}
                            </MaterialTypography>
                        }
                        sx={{ marginLeft: 0 }}
                        />
                    </Grid2>
                    {contacts.length > 1 && (
                    <Grid2 size={{ lg: 2 }}>
                        <MaterialBox mt={4}>
                            <Button color="error" onClick={() => handleRemoveContact(index)}>
                            Remove
                            </Button>
                        </MaterialBox>
                    </Grid2>
                    )}
                </Grid2>
                ))} */}
            </CardContent>
            <Divider/>
            <MaterialBox
                display="flex"
                justifyContent="space-between"
                alignItems="center"
            >
            {pageMode === "add" && (
            <>
                <MaterialButton
                sx={{ m: 2 }}
                variant="outlined"
                color="dark"
                onClick={() => navigate("/general-master/bank-branch-list")}
                >
                Cancel
                </MaterialButton>
                <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                disabled={!checkAllFields()}
                onClick={handleSubmitBankBranch}
                >
                Submit
                </MaterialButton>
            </>
            )}

            {pageMode==="edit" && (
            <>
                <MaterialButton
                variant="outlined"
                color="dark"
                sx={{ m: 2 }}
                onClick={() => navigate("/general-master/bank-branch-list")}
                >
                Cancel
                </MaterialButton>
                <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                disabled={!checkAllFields()}
                onClick={handleSubmitBankBranch}
                >
                Update
                </MaterialButton>
            </>
            )}
            </MaterialBox>
        </Card>
    </DashboardLayout>
  )
}

export default BankBranchForm